import React from 'react';

const searchChars = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9'
];

/**
 * @typedef {object} SearchControlAlphabeticalProps
 * @property {(char: string) => void} setSearchChar
 * @property {string} [selectedSearchChar]
 */

/**
 * @param {SearchControlAlphabeticalProps} props
 */
const SearchControlAlphabetical = props => {
  const { setSearchChar, selectedSearchChar } = props;
  const setActiveChar = char => {
    char == selectedSearchChar ? setSearchChar('') : setSearchChar(char);
  };

  const buildDesktopView = () => {
    return searchChars.map(char => (
      <button
        key={char}
        className={
          'search-controls__text-button' +
          (char === selectedSearchChar ? ' search-controls__text-button--active' : '')
        }
        onClick={() => setActiveChar(char)}>
        {char}
      </button>
    ));
  };

  return <div className='search-controls__alphabet'>{buildDesktopView()}</div>;
};

export default SearchControlAlphabetical;
